<template>
    <BaseModal
        class="bottom-modal"
        transition-name="bottom"
    >
        <h3
            v-if="title || $slots.title"
            class="bottom-modal__title"
        >
            <slot name="title">
                {{ title }}
            </slot>
        </h3>

        <p
            v-if="description || $slots.description"
            class="bottom-modal__description"
        >
            <slot name="description">
                {{ description }}
            </slot>
        </p>

        <slot />
    </BaseModal>
</template>


<script setup>
defineProps({
    title: {
        type: String,
        default: null
    },
    description: {
        type: String,
        default: null
    }
});
</script>

<style lang="less">
.dn-modal.bottom-modal {
    text-align: center;
    color: var(--color-secondary);

    .dn-modal__wrapper {
        display: grid;
        padding: 0;
    }

    .dn-modal__backdrop {
        transition: opacity 2s 0ms cubic-bezier(0.2, 0, 0, 1);
    }

    .dn-modal__dialog {
        margin: 0;
        justify-self: center;
        align-self: end;
        border-radius: var(--borderRadius-xl) var(--borderRadius-xl) 0 0;
        transition: transform .5s 0ms cubic-bezier(0.2, 0, 0, 1);
    }

    .dn-modal__main {
        display: flex;
        flex-direction: column;
        padding: var(--spacing-md) var(--spacing-xs);

        @media @q-sm-min {
            padding: var(--spacing-lg);
        }
    }

    .bottom-modal__title {
        .typography-h3();
        margin-bottom: var(--spacing-sm);
    }

    .bottom-modal__description {
        .typography-body();
        margin-bottom: var(--spacing-sm);
        margin-top: 0;
    }

    @media @q-sm-min {
        .dn-modal__dialog {
            --max-width: 30rem;
            align-self: center;
            border-radius: var(--borderRadius-xl);
        }
    }
}

.bottom-enter-from,
.bottom-leave-to {
    .dn-modal__backdrop,
    .dn-modal__backdrop:hover {
        opacity: 0;
    }

    .dn-modal__dialog {
        transform: translateY(100vh);
    }
}

.bottom-leave-active,
.bottom-enter-active {
    overflow: hidden;
}
</style>
